/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Purpose_Not_ReadyInputs */

const vi_error_zns_purpose_not_ready = /** @type {(inputs: Error_Zns_Purpose_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục đích chưa sẵn sàng gửi — kiểm tra kết nối và mẫu đã gán.`)
};

/**

* @param {Error_Zns_Purpose_Not_ReadyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_purpose_not_ready = /** @type {((inputs?: Error_Zns_Purpose_Not_ReadyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Purpose_Not_ReadyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_purpose_not_ready(inputs)
});